import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '../baseQuery'; // Import the custom baseQuery

const locationsGraphAPI = createApi({
  reducerPath: 'locationsGraphAPI',
  baseQuery: customBaseQuery, // Use custom baseQuery
  endpoints: (builder) => ({
    getActiveLocations: builder.query({
      query: () => ({
        url: "activeLocations",
        method: 'GET'
      }),
    }),
  }),
});

export const { useGetActiveLocationsQuery } = locationsGraphAPI;

export default locationsGraphAPI;
